<cm-card class="card">
    <cm-personal-info [profile]="profile" (updateProfile)="updateProfile($event)"></cm-personal-info>
</cm-card>
